import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const IntRoundTrip = ({
  data,
  totalPax,
  requestBody,
  flights,
  loading,
  error,
  handleBookNow,
}) => {
  const navigate = useNavigate();

  /** ---------------- Hooks must ALWAYS be at the top ---------------- */
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [selectedFare, setSelectedFare] = useState(null);

  /** ---------------- Utility Functions ---------------- */
  const formatTime = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const calcDuration = (start, end) => {
    if (!start || !end) return "—";
    const s = new Date(start);
    const e = new Date(end);
    const diff = Math.abs(e - s) / 1000 / 60;
    const h = Math.floor(diff / 60);
    const m = diff % 60;
    return `${h}h ${m}m`;
  };

  /** ---------------- NOW return early safely ---------------- */
  if (!loading && (!flights || flights.length === 0)) {
    return (
      <p className="text-center">No International Round-Trip Flights Found</p>
    );
  }
  const handleViewMoreFare = (flight) => {
    if (!flight) return;

    console.log("View More Fare", flight);
    setSelectedFlight(flight);
    setSelectedFare(null);

    setTimeout(() => {
      const offcanvas = document.getElementById("ViewMoreFare");
      if (offcanvas) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(offcanvas);
        bsOffcanvas.show();
      }
    }, 50); // wait for React to update state
  };

  return (
    <>
      {/* ---------- HEADER ----------- */}
      <div className="row ruslt_sort mb-3">
        <div className="col-md-6">
          <div className="d_flex_dxb">
            <span className="plac_nam">
              {data.departureAirportCode} → {data.arrivalAirportCode}
            </span>
            <span className="plac_nam_date">{data.onwardDate}</span>

          </div>
          <div className="d_flex_dxb">
            <span className="plac_nam">
              {data.arrivalAirportCode} → {data.departureAirportCode}
            </span>
            <span className="plac_nam_date">{data.returnDate}</span>
          </div>
        </div>

        <div className="col-md-6 text-end">

          <button
            className="modify_btn_sr"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result →
          </button>
        </div>
      </div>

      {/* ---------- LOADING / ERROR ---------- */}
      {loading && (
        <p className="text-center load">
          <span className="loader"></span>
        </p>
      )}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && flights.length === 0 && <p>No flights found.</p>}

      {/* ---------- FLIGHT LIST ---------- */}
      {!loading &&
        flights.map((f, idx) => {
          const onward = f.segments?.[0] || {};
          const ret = f.segments?.[1] || {};
          const totalFare =
            Number(f.fares?.[0]?.totalFare || f.fare?.totalFare || 0);

          return (
            <div className="result_repeat mb-2" key={idx}>
              <div className="row">
                {/* ---------- LEFT SIDE (FLIGHT DETAILS) ---------- */}
                <div className="col-md-9">
                  {/* ----- ONWARD ----- */}
                  <div className="row oneWay_flight_1">
                    <p className="mode_trvel">
                      <span>
                        <i className="fa fa-plane"></i> Departure
                      </span>
                    </p>

                    <div className="col-md-4 col-lg-4">
                      <div className="row">
                        <div className="col-md-4">
                          <img
                            src={`https://www.d2wtravel.com/Content/Flight_Images/${onward.airLineCode}.gif`}
                            width="30"
                            alt=""
                          />
                        </div>
                        <div className="col-md-8">
                          <span>
                            {onward.airLineCode}-{onward.flightNumber}
                          </span>
                          <div>{onward.airLineName}</div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-8 border-left-right">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="timer">
                            <h4>{onward.departDateTime?.slice(11, 16)}</h4>
                            <p>{onward.departAirportCode}</p>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="deruation">
                            <p>{onward.duration}</p>
                            <div className="bordr_top">
                              <i className="fa fa-plane"></i>
                            </div>
                            <p className="stops"> {onward.numberOfStops} stop</p>
                          </div>
                        </div>


                        <div className="col-md-4 offset-1">
                          <div className="timer">
                            <h4>{onward.arrivalDateTime?.slice(11, 16)}</h4>
                            <p>{onward.arrivalAirportCode}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ----- RETURN ----- */}
                  <div className="row oneWay_flight_2">
                    <p className="mode_trvel">
                      <span>
                        <i className="fa fa-plane"></i> Return
                      </span>
                    </p>

                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-4">
                          <img
                            src={`https://www.d2wtravel.com/Content/Flight_Images/${ret.airLineCode}.gif`}
                            width="30"
                            alt=""
                          />
                        </div>
                        <div className="col-md-8">
                          <span>
                            {ret.airLineCode}-{ret.flightNumber}
                          </span>
                          <div>{ret.airLineName}</div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-8 border-left-right">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="timer">
                            <h4>{ret.departDateTime?.slice(11, 16)}</h4>
                            <p>{ret.departAirportCode}</p>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="deruation">
                            <p>{ret.duration}</p>
                            <div className="bordr_top">
                              <i className="fa fa-plane"></i>
                            </div>
                            <p className="stops">{ret.numberOfStops} stop</p>
                          </div>
                        </div>



                        <div className="col-md-4 offset-1">
                          <div className="timer">
                            <h4>{ret.arrivalDateTime?.slice(11, 16)}</h4>
                            <p>{ret.arrivalAirportCode}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ----- Services / Refundability ----- */}
                  <div className="col-md-12">
                    <ul className="list_service">
                      <li>
                        <div className="d-flex">
                          <div className="equipmentType">
                            <i className="fa-solid fa-fan"></i>
                            <span>{onward.equipmentType}</span>
                          </div>
                          <div className="equipmentType">
                            <img
                              className="seats"
                              src="/assets/images/seat.png"
                              alt="seat"
                            />
                            <span>{onward.availableSeats} Seats</span>
                          </div>
                        </div>
                      </li>


                      <li className="refundable">
                        {f.fares?.[0]?.isRefundable ? (
                          <span style={{ color: "green" }}>
                            Refundable
                          </span>
                        ) : (
                          <span style={{ color: "red" }}>
                            Non-Refundable
                          </span>
                        )}
                      </li>

                      <li className="view_on">
                        <a className="flight_details"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#FlightDetails"
                          onClick={() => setSelectedFlight(f)}
                        >
                          <i className="fa fa-plane"></i> Flight Details
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* ---------- RIGHT SIDE (PRICE + BUTTONS) ---------- */}
                <div className="col-md-3">
                  <div className="price_int">
                    <div className="cos_int_flight">
                      <i className="fa fa-inr"></i>
                      {totalFare.toLocaleString()}
                    </div>


                    <button
                      className="view_more"
                      onClick={() => handleViewMoreFare(f)}
                    >
                      View More Fare
                    </button>

                    <button
                      className="book_now_fly"
                      onClick={() => handleBookNow(f)}
                    >
                      Book Now
                    </button>


                  </div>
                </div>


              </div>
            </div>
          );
        })}

      <div
        className="offcanvas offcanvas-end"
        id="ViewMoreFare"
        tabIndex="-1"
        aria-labelledby="ViewMoreFareLabel"
      >
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight.segments?.[0]?.airLineName || "airline"}
                    src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>
                <div className="flight_time">
                  <span>
                    <strong>
                      {selectedFlight.origin} ({selectedFlight.segments?.[0]?.departAirportCode}) →{" "}
                      {selectedFlight.destination} ({selectedFlight.segments?.[0]?.arrivalAirportCode})
                    </strong>
                  </span>
                  <span>
                    <strong>{selectedFlight.segments?.[0]?.airLineName}</strong>
                  </span>
                  <span>
                    <strong>
                      {new Date(
                        selectedFlight.segments?.[0]?.departDateTime
                      ).toDateString()}
                    </strong>
                  </span>
                  <span>
                    Departure at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</strong>
                  </span>
                  <span>
                    Arrival at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</strong>
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares?.length > 0 ? (
                  selectedFlight.fares.map((fare, index) => (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare.fareType || "Standard Fare"}</h5>
                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>

                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>



                      </div>

                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setSelectedFare(fare);
                            setSelectedFareIndex(index); // <-- IMPORTANT
                          }}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No fare options available</p>
                )}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>

        {selectedFare && (
          <div className="total_amount border-top p-3">
            <p className="Grand">Grand Total</p>
            <h1>
              <i className="fa fa-inr"></i>{" "}
              {selectedFare?.totalFare?.toLocaleString("en-IN")}
            </h1>

            <button
              className="btn btn-primary"
              onClick={() => handleBookNow(selectedFlight, selectedFareIndex)}
              disabled={loadingFlightIndex === selectedFareIndex}
            >
              {loadingFlightIndex === selectedFareIndex ? "Checking ..." : "Book Now"}
            </button>

          </div>
        )}
      </div>


      <div className="offcanvas offcanvas-end" tabIndex="-1" id="FlightDetails" aria-labelledby="FlightDetailsLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>

              <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#kt_tab_pane_4">Flight Information</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_5">Fare Details &amp; Rules</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_6">Baggage Information</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_7">Cancellation &amp; Change Rule</a></li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="kt_tab_pane_4" role="tabpanel">
                  <div className="row">

                    {/* ================= ONWARD LEG ================= */}
                    <div className="col-md-6">
                    <div className="int_don_flight">

                      <h3 className="destnation">
                        {selectedFlight.origin} ({selectedFlight.segments?.[0]?.departAirportCode})
                        <i className="fa fa-arrow-right"></i>
                        {selectedFlight.destination} ({selectedFlight.segments?.[0]?.arrivalAirportCode})
                      </h3>

                      <ul className="rlst_flight_detls">
                        <li>{selectedFlight.selClass || "Economy"}</li>
                        <li>{selectedFlight.adult + selectedFlight.child + selectedFlight.infant} Traveller(s)</li>
                        <li>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</li>
                      </ul>

                      <div className="d-flex flgt_dlts">
                        <div className="img_img_flight">
                          <img
                            className="flight_i"
                            src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                            alt={selectedFlight.segments?.[0]?.airLineName}
                          />
                        </div>
                        <div className="text_img_t">
                          <h5>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</h5>
                          <p>
                            {selectedFlight.origin} - {selectedFlight.destination} |
                            {selectedFlight.segments?.[0]?.duration || "Duration N/A"}
                          </p>
                        </div>
                      </div>

                      {/* ONWARD – DEPARTURE INFO */}
                      <div className="d-flex-v">
                        <div className="d-flex-v-f">
                          <h4>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</h4>
                        </div>
                        <div className="d-flex-v-m"><span className="zero"></span></div>
                        <div className="d-flex-v-l">
                          <h4>{selectedFlight.origin}</h4>
                          <p>
                            {selectedFlight.segments?.[0]?.departAirportName}
                            {selectedFlight.segments?.[0]?.departTerminal ? `, Terminal ${selectedFlight.segments[0].departTerminal}` : ""}
                          </p>
                        </div>
                      </div>

                      {/* ONWARD – SEGMENT LIST */}
                      <div className="d-flex-v time_to_frm">
                        <div className="d-flex-v-l m-autto">
                          {selectedFlight.segments?.filter(seg => seg.journeyType === "Onward").map((seg, index) => (
                            <div key={index} className="d-flex mb-3 align-items-center">

                              <div className="d-flex-v-f m-autto me-3">
                                <h6>{new Date(seg.departDateTime).toDateString()}</h6>
                                <p className="mb-0">
                                  {formatTime(seg.departDateTime)} ➜ {formatTime(seg.arrivalDateTime)}
                                </p>
                              </div>

                              <div className="d-flex-v-m fhty_rg">
                                <i className="fa fa-plane flights"></i>
                              </div>

                              <div className="d-flex">
                                <div className="img_flt">
                                  <img
                                    className="flight_i"
                                    src={`https://www.d2wtravel.com/Content/Flight_Images/${seg.airLineCode}.gif`}
                                    alt={seg.airLineName}
                                  />
                                </div>

                                <div className="flt_name ms-2">
                                  {seg.airLineName} - {seg.airLineCode}-{seg.flightNumber}

                                  {index < selectedFlight.segments.filter(s => s.journeyType === "Onward").length - 1 && (
                                    <span className="mx-2"><i className="fa fa-arrow-right"></i></span>
                                  )}
                                </div>
                              </div>

                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Repeat stoped start */}


                      {/* --- Onward Flight Segments --- */}
                      {selectedFlight?.segments?.map((seg, index) => (
                        <div key={index} className="d-flex-v time_to_frm">
                          <div className="d-flex-v-l m-autto">
                            <div className="d-flex mb-3 align-items-center">

                              {/* Times */}
                              <div className="d-flex-v-f m-autto me-3">
                                <h6>{new Date(seg.departDateTime).toDateString()}</h6>
                                <p className="mb-0">
                                  {seg.departTime} ➜ {seg.arrivalTime}
                                </p>
                              </div>

                              {/* Plane Icon */}
                              <div className="d-flex-v-m fhty_rg">
                                <i className="fa fa-plane flights"></i>
                              </div>

                              {/* Airline Image + Name */}
                              <div className="d-flex">
                                <div className="img_flt">
                                  <img
                                    className="flight_i"
                                    src={`https://www.d2wtravel.com/Content/Flight_Images/${seg.airLineCode}.gif`}
                                    alt={seg.airLineName}
                                  />
                                </div>

                                <div className="flt_name ms-2">
                                  {seg.airLineName} - {seg.airLineCode}-{seg.flightNumber}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Show stop only if more segments exist */}
                          {index < selectedFlight.segments.length - 1 && (
                            <div className="layover-box text-center mb-3">
                              <p className="mb-0">
                                Stop at <strong>{seg.arrivalAirportCode}</strong>
                              </p>
                            </div>
                          )}
                        </div>
                      ))}


                      {/* Repeat stoped End */}


                      {/* ONWARD – ARRIVAL INFO */}
                      <div className="d-flex-v">
                        <div className="d-flex-v-f">
                          <h4>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</h4>
                        </div>
                        <div className="d-flex-v-m"><span className="zero"></span></div>
                        <div className="d-flex-v-l">
                          <h4>{selectedFlight.destination}</h4>
                          <p>
                            {selectedFlight.segments?.[0]?.arrivalAirportName}
                            {selectedFlight.segments?.[0]?.arrivalTerminal ? `, Terminal ${selectedFlight.segments[0].arrivalTerminal}` : ""}
                          </p>
                        </div>
                      </div>

                    </div>
                    </div>

                    {/* ================= RETURN LEG ================= */}
                    <div className="col-md-6">
                    <div className="int_don_flight">

                      <h3 className="destnation">
                        {selectedFlight.destination} ({selectedFlight.segments?.[1]?.departAirportCode})
                        <i className="fa fa-arrow-right"></i>
                        {selectedFlight.origin} ({selectedFlight.segments?.[1]?.arrivalAirportCode})
                      </h3>

                      <ul className="rlst_flight_detls">
                        <li>{selectedFlight.selClass || "Economy"}</li>
                        <li>{selectedFlight.adult + selectedFlight.child + selectedFlight.infant} Traveller(s)</li>
                        <li>{new Date(selectedFlight.segments?.[1]?.departDateTime).toDateString()}</li>
                      </ul>

                      <div className="d-flex flgt_dlts">
                        <div className="img_img_flight">
                          <img
                            className="flight_i"
                            src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[1]?.airLineCode}.gif`}
                            alt={selectedFlight.segments?.[1]?.airLineName}
                          />
                        </div>
                        <div className="text_img_t">
                          <h5>{new Date(selectedFlight.segments?.[1]?.departDateTime).toDateString()}</h5>
                          <p>
                            {selectedFlight.destination} - {selectedFlight.origin} |
                            {selectedFlight.segments?.[1]?.duration || "Duration N/A"}
                          </p>
                        </div>
                      </div>



                      {/* RETURN – DEPARTURE INFO */}
                      <div className="d-flex-v">
                        <div className="d-flex-v-f">
                          <h4>{formatTime(selectedFlight.segments?.[1]?.departDateTime)}</h4>
                        </div>
                        <div className="d-flex-v-m"><span className="zero"></span></div>
                        <div className="d-flex-v-l">
                          <h4>{selectedFlight.destination}</h4>
                          <p>
                            {selectedFlight.segments?.[1]?.departAirportName}
                            {selectedFlight.segments?.[1]?.departTerminal ? `, Terminal ${selectedFlight.segments[1].departTerminal}` : ""}
                          </p>
                        </div>
                      </div>
                      {/* Repeat stoped start */}

                      {/* --- Onward Flight Segments --- */}
                      {selectedFlight?.segments?.map((seg, index) => (
                        <div key={index} className="d-flex-v time_to_frm">
                          <div className="d-flex-v-l m-autto">
                            <div className="d-flex mb-3 align-items-center">

                              {/* Times */}
                              <div className="d-flex-v-f m-autto me-3">
                                <h6>{new Date(seg.departDateTime).toDateString()}</h6>
                                <p className="mb-0">
                                  {seg.departTime} ➜ {seg.arrivalTime}
                                </p>
                              </div>

                              {/* Plane Icon */}
                              <div className="d-flex-v-m fhty_rg">
                                <i className="fa fa-plane flights"></i>
                              </div>

                              {/* Airline Image + Name */}
                              <div className="d-flex">
                                <div className="img_flt">
                                  <img
                                    className="flight_i"
                                    src={`https://www.d2wtravel.com/Content/Flight_Images/${seg.airLineCode}.gif`}
                                    alt={seg.airLineName}
                                  />
                                </div>

                                <div className="flt_name ms-2">
                                  {seg.airLineName} - {seg.airLineCode}-{seg.flightNumber}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Show stop only if more segments exist */}
                          {index < selectedFlight.segments.length - 1 && (
                            <div className="layover-box text-center mb-3">
                              <p className="mb-0">
                                Stop at <strong>{seg.arrivalAirportCode}</strong>
                              </p>
                            </div>
                          )}
                        </div>
                      ))}


                      {/* Repeat stoped End */}
                      {/* RETURN – SEGMENT LIST */}
                      <div className="d-flex-v time_to_frm">
                        <div className="d-flex-v-l m-autto">
                          {selectedFlight.segments?.filter(seg => seg.journeyType === "Return").map((seg, index) => (
                            <div key={index} className="d-flex mb-3 align-items-center">

                              <div className="d-flex-v-f m-autto me-3">
                                <h6>{new Date(seg.departDateTime).toDateString()}</h6>
                                <p className="mb-0">
                                  {formatTime(seg.departDateTime)} ➜ {formatTime(seg.arrivalDateTime)}
                                </p>
                              </div>

                              <div className="d-flex-v-m fhty_rg">
                                <i className="fa fa-plane flights"></i>
                              </div>

                              <div className="d-flex">
                                <div className="img_flt">
                                  <img
                                    className="flight_i"
                                    src={`https://www.d2wtravel.com/Content/Flight_Images/${seg.airLineCode}.gif`}
                                    alt={seg.airLineName}
                                  />
                                </div>

                                <div className="flt_name ms-2">
                                  {seg.airLineName} - {seg.airLineCode}-{seg.flightNumber}
                                  {index < selectedFlight.segments.filter(s => s.journeyType === "Return").length - 1 && (
                                    <span className="mx-2"><i className="fa fa-arrow-right"></i></span>
                                  )}
                                </div>
                              </div>

                            </div>
                          ))}
                        </div>
                      </div>

                      {/* RETURN – ARRIVAL INFO */}
                      <div className="d-flex-v">
                        <div className="d-flex-v-f">
                          <h4>{formatTime(selectedFlight.segments?.[1]?.arrivalDateTime)}</h4>
                        </div>
                        <div className="d-flex-v-m">
                          <span className="zero"></span>
                        </div>
                        <div className="d-flex-v-l">
                          <h4>{selectedFlight.origin}</h4>
                          <p>
                            {selectedFlight.segments?.[1]?.arrivalAirportName}
                            {selectedFlight.segments?.[1]?.arrivalTerminal ? `, Terminal ${selectedFlight.segments[1].arrivalTerminal}` : ""}
                          </p>
                        </div>
                      </div>

                    </div>
                    </div>
                  </div>

                </div>
                <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to cancel<br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Cancel Before 72 hours of departure time.</td>
                              <td>3,999</td>

                            </tr>
                            <tr>
                              <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>3,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to reschedule <br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Reschedule before 72 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>
                            <tr>
                              <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <h4>Terms &amp; Conditions</h4>
                        <ul>
                          <li>Total Rescheduling Charges Airlines Rescheduling fees Fare Difference if applicable.</li>
                          <li>The airline cancel reschedule fees is indicative and can be changed without any prior notice by the airlines..</li>
                          <li>Berry Journeys does not guarantee the accuracy of cancel reschedule fees.</li>
                          <li>Partial cancellation is not allowed on the flight tickets which are book under special round trip discounted fares.</li>
                          <li>Airlines doesnt allow any additional baggage allowance for any infant added in the booking</li>
                          <li>In certain situations of restricted cases, no amendments and cancellation is allowed</li>
                          <li>Airlines cancel reschedule should be reconfirmed before requesting for a cancellation or amendment</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_7" role="tabpanel">
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to cancel <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Cancel Before 72 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>4,999</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to reschedule <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Reschedule before 72 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="total_amount">
                <p class="Grand">Grand Total</p>
                <h1>
                  <i className="fa fa-inr"></i>{" "}
                  {Number(selectedFlight.fares?.[0]?.totalFare || 0).toLocaleString()}
                </h1>
                {/* <button class="btn btn-primary">Book Now</button> */}
                <button
                  className="btn btn-primary"
                  onClick={() => handleBookNow(selectedFlight, selectedFareIndex)}
                  disabled={loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex}
                >
                  {loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex
                    ? "CheckingPrice..."
                    : "Book Now"}
                </button>

              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>

    </>
  );
};

export default IntRoundTrip;
